exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-width-search-bar{padding:10px;background:#ccc}.full-width-search-bar .container{padding-top:0;padding-bottom:0}.search-bar{margin:0 auto}.search-bar .input-search,.search-bar button{height:50px;font-size:20px}.search-bar .toggleSearchText{font-size:20px}.search-bar .toggleSearchText i.fa.fa-pause{position:relative;top:calc(50% - 14.5px)}", ""]);

// exports
